/**
 * Women Spot Premium Footer
 * Mobile Accordion
 * Shopify Dawn 16.0.0
 */

(function () {
  'use strict';

  const FOOTER_SELECTOR =
    '[data-women-spot-footer]';

  const ACCORDION_SELECTOR =
    '[data-women-spot-footer-accordion]';

  const MOBILE_BREAKPOINT = 749;

  function closeAccordion(
    accordion
  ) {
    if (!accordion) return;

    const button =
      accordion.querySelector(
        '.women-spot-footer-mobile-heading'
      );

    accordion.classList.remove(
      'is-open'
    );

    if (button) {
      button.setAttribute(
        'aria-expanded',
        'false'
      );
    }
  }

  function openAccordion(
    accordion
  ) {
    if (!accordion) return;

    const footer = accordion.closest(
      FOOTER_SELECTOR
    );

    const button =
      accordion.querySelector(
        '.women-spot-footer-mobile-heading'
      );

    /*
     * दुसरा open accordion बंद करा.
     */
    if (footer) {
      footer
        .querySelectorAll(
          ACCORDION_SELECTOR
        )
        .forEach(function (item) {
          if (item !== accordion) {
            closeAccordion(item);
          }
        });
    }

    accordion.classList.add(
      'is-open'
    );

    if (button) {
      button.setAttribute(
        'aria-expanded',
        'true'
      );
    }
  }

  function toggleAccordion(
    button
  ) {
    /*
     * Accordion फक्त mobile वर.
     */
    if (
      window.innerWidth >
      MOBILE_BREAKPOINT
    ) {
      return;
    }

    const accordion =
      button.closest(
        ACCORDION_SELECTOR
      );

    if (!accordion) return;

    if (
      accordion.classList.contains(
        'is-open'
      )
    ) {
      closeAccordion(accordion);
    } else {
      openAccordion(accordion);
    }
  }

  function updateResponsiveState(
    footer
  ) {
    const isMobile =
      window.innerWidth <=
      MOBILE_BREAKPOINT;

    footer
      .querySelectorAll(
        ACCORDION_SELECTOR
      )
      .forEach(function (accordion) {
        const button =
          accordion.querySelector(
            '.women-spot-footer-mobile-heading'
          );

        /*
         * Desktop वर सर्व content visible.
         */
        if (!isMobile) {
          accordion.classList.remove(
            'is-open'
          );

          if (button) {
            button.setAttribute(
              'aria-expanded',
              'true'
            );
          }
        } else if (
          !accordion.classList.contains(
            'is-open'
          )
        ) {
          if (button) {
            button.setAttribute(
              'aria-expanded',
              'false'
            );
          }
        }
      });
  }

  function initializeFooter(
    footer
  ) {
    if (
      !footer ||
      footer.dataset
        .womenSpotFooterReady ===
        'true'
    ) {
      return;
    }

    footer.dataset.womenSpotFooterReady =
      'true';

    footer
      .querySelectorAll(
        '.women-spot-footer-mobile-heading'
      )
      .forEach(function (button) {
        button.addEventListener(
          'click',
          function () {
            toggleAccordion(button);
          }
        );
      });

    updateResponsiveState(footer);
  }

  function initializeAllFooters(
    root
  ) {
    const container =
      root || document;

    /*
     * Theme Editor मध्ये section
     * स्वतः root असेल तर.
     */
    if (
      container.matches &&
      container.matches(
        FOOTER_SELECTOR
      )
    ) {
      initializeFooter(container);
    }

    container
      .querySelectorAll(
        FOOTER_SELECTOR
      )
      .forEach(function (footer) {
        initializeFooter(footer);
      });
  }

  let resizeTimer;

  window.addEventListener(
    'resize',
    function () {
      window.clearTimeout(
        resizeTimer
      );

      resizeTimer =
        window.setTimeout(
          function () {
            document
              .querySelectorAll(
                FOOTER_SELECTOR
              )
              .forEach(
                function (footer) {
                  updateResponsiveState(
                    footer
                  );
                }
              );
          },
          150
        );
    },
    {
      passive: true
    }
  );

  /*
   * Normal page initialization.
   */
  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initializeAllFooters(
          document
        );
      }
    );
  } else {
    initializeAllFooters(document);
  }

  /*
   * Shopify Theme Editor support.
   */
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initializeAllFooters(
        event.target
      );
    }
  );

  document.addEventListener(
    'shopify:section:unload',
    function (event) {
      const footer =
        event.target.querySelector(
          FOOTER_SELECTOR
        );

      if (footer) {
        footer.dataset
          .womenSpotFooterReady =
          'false';
      }
    }
  );
})();